const React = require('react');
const createReactClass = require('create-react-class');
const assign = require('object-assign');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const CodesStore = require('../../stores/CodeStore');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
const CodePage = createReactClass({
    displayName: 'CodePage',

    getInitialState: function () {
        return {
            currentPageData: [],
            openDeactivateModal: false,
            workingResource: {}
        }
    },

    getOptions: {
        modifiers: {
            include: ['id'],
            filters: {},
            other: {
                show_deleted: true
            }
        },
        pagination: {
            per_page: '10'
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        pagination: {
            per_page: '20'
        },
        dataNode: 'data',
        refresh: 'list'
    },

    resourceActions: new ResourceActions('generation-codes'),

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        // Merge modifiers with already present ones
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});
        this.resourceActions.listResource(this.getOptions);
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        this.requestTableData();

        this.changeListener = this._onChange;
        CodesStore.addChangeListener(this.changeListener);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        CodesStore.removeChangeListener(this.changeListener);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            currentPageData: CodesStore.getResourceListData()
        });
    },

    /**
     * @todo the modals can be their own components
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {

        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'create':
                this.props.history.push(`/codes/manage-code/`);
                break;
            case 'View':
                this.props.history.push(`/codes/${resource.id}`);
                break;
            case 'edit':
                this.props.history.push(`/codes/manage-code/${resource.id}`);
                break;
            case 'deactivate':
                this.setState({
                    openDeactivateModal: true,
                    workingResource: resource,
                    resourceOperation: action
                });
                break;
        }
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            openDeactivateModal: false,
            workingResource: {} // Reset working resource
        });
    },

    /**
     * Map code object properties to table columns
     */
    tableKeys: {
        "Prefix": "prefix",
        "Length": "num_days",
        "Codes": "num_codes",
        "Expiration": "expiration"

    },

    render: function () {
        // Set up table options
        const tableOptions = {
            actionableRows: true,
            actions: ['View:primary', 'edit:info'],
            actionsCallback: this.handleAction,
            mutators: {}
        };

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"></div>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="8">
                            <h1 className="page-header">Codes Generation</h1>
                        </Column>

                        <Column grid="lg" size="4">
                            <div className="page-header">
                                <PageSearch actionMethod={this.requestTableData}
                                            searchable={['prefix']}/>
                            </div>
                        </Column>
                    </Row>

                    <Row>
                        <Column grid="lg" size="12">
                            <Table data={this.state.currentPageData}
                                   dataKeys={this.tableKeys}
                                   title={'Active Codes'} options={tableOptions}/>
                            <Paginator actionMethod={this.requestTableData}/>

                            <PerPageSelector actionMethod={this.requestTableData}/>
                        </Column>
                    </Row>
                </div>

                <AddAction createResource={this.handleAction}/>
            </div>
        )
    },
});

module.exports = CodePage;
